import { jarallax, jarallaxVideo } from "jarallax";

jarallax(document.querySelectorAll('.jarallax'), {
	speed: 0.8,
	disableParallax: /iPad|iPhone|iPod|Android/,
	disableVideo: /iPad|iPhone|iPod|Android/
});


// Scroll listener - this outputs the css property --scroll
// window.addEventListener('scroll', () => {
// 	document.body.style.setProperty('--scroll', window.pageYOffset / (document.body.offsetHeight - window.innerHeight));
// }, false);
